import { render } from "./MpeV3B-1.vue?vue&type=template&id=44edc6e5&ts=true"
import script from "./MpeV3B-1.vue?vue&type=script&lang=ts"
export * from "./MpeV3B-1.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__